import React, { useState } from "react";
import "./MediaSection.css";


const mediaItems = [
//   {
//     title: "UKSC",
//     text: `Having started its journey in the summer of 2024, United Kolkata Sports Club is a
// vibrant footballing entity, fuelled with unrivalled passion and big dreams. ​`,
//     image: "/images/sports/uksc.jpg",
//     link: "https://www.aajkaal.in/",
//   },
  {
    title: "Techno India Manchester City Football School",
    text: `An attempt to transform the grassroot football ecosystem in India, couldn’t have been
bigger and better – in close collaboration with the world-famous City Football Group. ​`,
    image: "/images/sports/mancity.jpg",
    link: "https://tigmancity.technoindiagroup.in/",
  },
];


export default function MediaSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(null);

  const changeBG = (index) => {
    if (index === activeIndex) return;

    setNextIndex(index);

    setTimeout(() => {
      setActiveIndex(index);
      setNextIndex(null);
    }, 600);
  };

  const activeItem = mediaItems[activeIndex];
  const nextItem =
    nextIndex !== null ? mediaItems[nextIndex] : null;

  return (
    <section className="media-wrapper">

      <div className="media-top">
        <h2>Sports</h2>

        <a href="/sports" className="learn-more">
          <i className="bi bi-arrow-right-circle-fill"></i>
          Learn more
        </a>
      </div>

      <div className="media-section">

        <div
          className="media-bg"
          style={{
            backgroundImage: `url(${activeItem.image})`,
          }}
        />

        {nextItem && (
          <div
            className="media-bg media-bg-next"
            style={{
              backgroundImage: `url(${nextItem.image})`,
            }}
          />
        )}

        <div className="overlay"></div>

        <div className="media-inner container">

          <div className="media-menu">
            {mediaItems.map((item, i) => (
              <div
                key={i}
                className={`media-menu-item ${activeIndex === i ? "active" : ""}`}
                onMouseEnter={() => changeBG(i)}
              >
                {item.title}
              </div>
            ))}
          </div>

          <div className="media-content">
            <h3>{activeItem.title}</h3>

            <div className="media-text-box">
              <p>{activeItem.text}</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
